const LOGO_URL = "https://customer-assets.emergentagent.com/job_64eb10e1-fdde-4977-afc2-4761fbf5691b/artifacts/5pkoywp1_Plouton_Logo%20%281%29.png";
const SITE_URL = "https://plouton.co";

// Safe JSON-LD serialization — escapes </script> to prevent injection
const safeJsonLd = (data) => {
  return JSON.stringify(data).replace(/<\/script/gi, '<\\/script');
};

const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: safeJsonLd(data) }}
  />
);

export const OrganizationSchema = () => (
  <JsonLd data={{
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Plouton AI",
    "url": SITE_URL,
    "logo": LOGO_URL,
    "description": "Autonomous finance workers for companies operating at scale. AI agents that automate your month-end close, AP, and reconciliations.",
    "foundingDate": "2024",
    "founders": [
      { "@type": "Person", "name": "Muhammad Furqan Karim Kidwai", "jobTitle": "CEO" },
      { "@type": "Person", "name": "Sarfaraz Hussain", "jobTitle": "CTO" }
    ],
    "sameAs": [
      "https://www.linkedin.com/company/plouton-ai"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "url": "https://cal.com/muhammad-furqan-karim-kidwai-uvsohz/30min"
    }
  }} />
);

export const ProductSchema = ({ name, description, url }) => (
  <JsonLd data={{
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": name || "Plouton AI",
    "applicationCategory": "FinanceApplication",
    "operatingSystem": "Web",
    "description": description || "AI-powered financial close software that automates month-end close, bank reconciliations, and accounts payable.",
    "url": url || SITE_URL,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "description": "Book a demo for pricing"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Plouton AI",
      "url": SITE_URL,
      "logo": LOGO_URL
    }
  }} />
);

export const FAQSchema = ({ faqs }) => (
  <JsonLd data={{
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  }} />
);

export const EventSchema = ({ name, description, startDate, endDate, url, performer }) => (
  <JsonLd data={{
    "@context": "https://schema.org",
    "@type": "Event",
    "name": name,
    "description": description,
    "startDate": startDate,
    "endDate": endDate,
    "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
    "eventStatus": "https://schema.org/EventScheduled",
    "location": {
      "@type": "VirtualLocation",
      "url": url || `${SITE_URL}/webinar`
    },
    "organizer": {
      "@type": "Organization",
      "name": "Plouton AI",
      "url": SITE_URL
    },
    "performer": {
      "@type": "Person",
      "name": performer || "Muhammad Furqan Karim Kidwai"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "url": `${SITE_URL}/webinar`
    },
    "image": LOGO_URL
  }} />
);

export const ArticleSchema = ({ title, description, url, datePublished }) => (
  <JsonLd data={{
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "description": description,
    "url": url,
    "datePublished": datePublished,
    "author": {
      "@type": "Organization",
      "name": "Plouton AI",
      "url": SITE_URL
    },
    "publisher": {
      "@type": "Organization",
      "name": "Plouton AI",
      "url": SITE_URL,
      "logo": { "@type": "ImageObject", "url": LOGO_URL }
    }
  }} />
);

export const WebPageSchema = ({ name, description, url }) => (
  <JsonLd data={{
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": name,
    "description": description,
    "url": url,
    "publisher": {
      "@type": "Organization",
      "name": "Plouton AI",
      "url": SITE_URL,
      "logo": LOGO_URL
    }
  }} />
);

export default JsonLd;
